import {ActionIcon, Code, CopyButton, Group, rem, Table, Text, Tooltip} from "@mantine/core";
import {IconCopy, IconFolderOpen} from "@tabler/icons-react";
import React from "react";

export default function TableCellComponent({data, related = false, copy = false, onOpenRelated}: {
    data: string,
    related: boolean,
    copy: boolean,
    onOpenRelated?: (data: string) => void,
}) {
    return (
        <Table.Td>
            <Group>
                {data?.toString().charAt(0) === '<' ? (
                    <Tooltip label={data} position={"bottom"} withArrow multiline w={500}
                             inline transitionProps={{transition: "fade-down", duration: 200}}>
                        <Code variant={"subtle"}>
                            {'<iframe />'}
                        </Code>
                    </Tooltip>) : <Text>{data}</Text>}
                {copy && <CopyButton value={data}>
                    {({copied, copy}) => (
                        <ActionIcon
                            variant={"subtle"} onClick={copy} color={copied ? 'green' : ''} className={"cell-action-button"}>
                            <IconCopy style={{width: rem(16), height: rem(16)}}
                                      stroke={1}/>
                        </ActionIcon>
                    )}
                </CopyButton>}
                {related && <ActionIcon variant={"subtle"} onClick={() => onOpenRelated && onOpenRelated(data)} className={"cell-action-button"}>
                    <IconFolderOpen style={{width: rem(16), height: rem(16)}} stroke={1}/>
                </ActionIcon>}
            </Group>
        </Table.Td>
    )
}
